module.exports = __webpack_public_path__ + "img/brillante_5.4096a837.svg";